import { useEffect, useState } from 'react'
import { urlApi } from '../utils/strings'
import { ParticipanteI } from '../components/Registro/ParticipanteModal'

const useFetchParticipantes = () => {

    const [participantes, setParticipantes] = useState<ParticipanteI[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        fetch(urlApi('/evento/listarParticipantes.php'))
            .then(res => res.json())
            .then(json => {
                if (json.status === 'success') setParticipantes(json.data)
            })
            .finally(() => setLoading(false))
    }, [])

    return { participantes, loading }
}

export default useFetchParticipantes
